<template>
  <v-container fluid fill-height class="home-hero">
    <v-layout justify-center align-center column pa-5>
      <div class="display-3 font-weight-black white--text text-xs-center">DEEP WORK HOURS</div>
      <div class="headline font-weight-bold white--text text-xs-center">A tool designed for you to practise deep work activities.</div>
      <div id="firebaseui-auth-container"></div>
    </v-layout>
  </v-container>
</template>

<script>
import { ui, auth } from '../main'
import firebase from '@firebase/app'
import * as firebaseui from 'firebaseui'

export default {
  name: 'Login',
  data: function (){
    return {
      isLoggedIn: false
    };
  },
  mounted: function () {
    this.$ga.page('/login');

    ui.start('#firebaseui-auth-container', {
      callbacks: {
        signInSuccessWithAuthResult: () => {
          return false;
        }
      },
      // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
      signInFlow: 'redirect',
      autoUpgradeAnonymousUsers: false,
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID
      ],
      // Required to enable one-tap sign-up credential helper.
      credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO
    });

    auth.onAuthStateChanged((user) => {
      if (user) {
        this.$router.push({ path: `/focus` })
      }
    });
  }
}
</script>

<style>
  @import url('../../node_modules/firebaseui/dist/firebaseui.css');

  .home-hero {
    background: url('http://source.unsplash.com/kZvmEpyfiJs');
    background-size: cover;
    width: 100%;
    height: 100%;
  }
</style>
